export const getArrayValue = (data = [], key = '', value = '', child = 'children') => {
    let reObj = {};
    const mapArray = (data = [], key = '', value = '') => {
        data.map((item, n) => {
            if (item[key] == value) {
                reObj = item;
            } else {
                if (item[child] && item[child].length > 0) {
                    mapArray(item[child], key, value)
                }
            }
        })
    }

    mapArray(data, key, value)

    return reObj

}

export const searchTree = (ele, key, value, child) => {
    if (ele[key] == value) {
        return ele;
    } else if (ele[child] != null) {
        let i;
        let result = null;
        for (i = 0; result == null && i < ele[child].length; i++) {
            result = searchTree(ele[child][i], value);
        }
        return result;
    }
    return {};
}

// 数组转换为tree
export const arrToTree = (ele, id, pid, child = 'lists') => {
    let parents = ele.filter(value => value[pid] == 'undefined' || value[pid] == null)
    let children = ele.filter(value => value[pid] !== 'undefined' && value[pid] != null)
    let translator = (parents, children) => {
        parents.forEach((parent) => {
            children.forEach((current, index) => {
                    if (current[pid] === parent[id]) {
                        let temp = JSON.parse(JSON.stringify(children))
                        temp.splice(index, 1)
                        translator([current], temp)
                        typeof parent[child] !== 'undefined' ? parent[child].push(current) : parent[child] = [current]
                    }
                }
            )
        })
    }

    translator(parents, children)

    return parents
}

export function listToTree(oldArr){
    oldArr.forEach(element => {
      element.key = element.id,
      element.title = element.name
      element.value = element.id,
      element.label = element.name
      let parentId = element.pid;
      if(parentId > 0){
        oldArr.forEach(ele => {
          if(ele.id == parentId){ //当内层循环的ID== 外层循环的parendId时，（说明有children），需要往该内层id里建个children并push对应的数组；
            if(!ele.children){
              ele.children = [];
            }
            ele.children.push(element);
          }
        });
      }
    });
    console.log(oldArr) //此时的数组是在原基础上补充了children;
    oldArr = oldArr.filter(ele => ele.pid === undefined); //这一步是过滤，按树展开，将多余的数组剔除；
    console.log(oldArr)
    return oldArr;
  }
export function copyObjsKeyVal(arr, keyMap){
  arr.forEach((element, index) => {
    for(let key in keyMap){
      element[keyMap[key]] = element[key]
    }
    element.sortKey = index
    if(element.children){
      copyObjsKeyVal(element.children)
    }
  });
  return arr
}